/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import { get } from "lodash";

import { IErrorObject } from "../../../../types/platform/universe";

import { BreakpointObserver } from "@angular/cdk/layout";
import { Overlay } from "@angular/cdk/overlay";
import { Component, Input, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";

import { environment } from "../../../environments/environment";

import { SessionService } from "../../platform/base/services/session.service";

import { ResponsiveComponent } from "../../platform/base/components/responsive.component";
import { MessageDialogComponent } from "../base/components/message-dialog/message-dialog.component";
import { TranslateService } from "@ngx-translate/core";

/**
 * todo
 */
@Component({
	selector: "aigia-shot",
	templateUrl: "./shot.component.html",
	styleUrls: ["./shot.component.css"],
})
export class ShotComponent extends ResponsiveComponent implements OnInit {
	@Input() data: any;
	@Input() modeviewadvice: boolean;
	@Input() modeviewavg: boolean;


	public params: any = {};
	public aligns: any = {};
	public endPoint: string = "";
	public smVideosSide: string[] = [];
	public smVideosBack: string[] = [];
	public prizmVideos: string[] = [];
	public smImages: any[] = [];
	public prizmImages: any[] = [];
	public shots: any[] = [];

	public ballistic: boolean = true;

	public service: any;

	private defaultLayouts = {
		components: [
			{ component: "app-video-table", size: [400, 300] },
			{ component: "app-video-table", size: [400, 300] },
			{ component: "app-posture-tab", size: [690, 690] },
			{
				component: "app-ballistic-chart",
				size: [500, 250],
				name: "ミート率",
			},
			{ component: "app-ballistic-tab", size: [400, 200] },
		],
	};

	constructor(
		public matDialog: MatDialog,
		protected session: SessionService,
		protected overlay: Overlay,
		protected snackbar: MatSnackBar,
		protected breakpointObserver: BreakpointObserver,
		public translate: TranslateService
	) {
		super(session, breakpointObserver);
		this.endPoint = environment.endPoint;
	}

	/**
	 * エラーダイアログ
	 *
	 * @returns none
	 */
	private errorDialog(
		error: IErrorObject,
		callback: (result: any) => void = (error: IErrorObject) => {}
	): void {
		if (error) {
			const dialog: MatDialogRef<any> = this.matDialog.open(
				MessageDialogComponent,
				{
					width: "30%",
					minWidth: "320px",
					height: "fit-content",
					data: {
						content: {
							title: "Error.",
							message: error.message,
							tag: error.tag,
						},
					},
					disableClose: true,
				}
			);

			dialog.afterClosed().subscribe((result: any): void => {
				callback(result);
			});
		}
	}

	/**
	 * @returns none
	 */
	private drawContent(
		shot: any,
		callback: (error: IErrorObject) => void
	): void {
		this.shots = [shot];

		this.smVideosSide.length = 0;
		this.smVideosBack.length = 0;
		this.prizmVideos.length = 0;
		this.prizmImages.length = 0;
		this.smImages.length = 0;

		if (shot.platform.files) {
			const prizmImageArray: any[] = [];
			if (shot.platform.files.prizm) {
				prizmImageArray.push(get(shot, "platform.files.prizm.image1"));
				prizmImageArray.push(get(shot, "platform.files.prizm.image2"));
			}
			this.prizmImages.push(prizmImageArray);

			if (shot.platform.files.sm) {
				const gcp = environment.gcp;

				const sm_side_video_fileName: string = get(
					shot,
					"platform.files.sm.video1[0].filename"
				); // if exist?
				this.smVideosSide.push(
					gcp.storage_service +
						"/" +
						gcp.bucket_name +
						"/" +
						sm_side_video_fileName
				);

				const sm_back_video_fileName: string = get(
					shot,
					"platform.files.sm.video2[0].filename"
				); // if exist?
				this.smVideosBack.push(
					gcp.storage_service +
						"/" +
						gcp.bucket_name +
						"/" +
						sm_back_video_fileName
				);

				// SM Images
				const smImageArray: any[] = [];
				smImageArray.push(get(shot, "platform.files.sm.image1"));
				smImageArray.push(get(shot, "platform.files.sm.image2"));
				smImageArray.push(get(shot, "platform.files.sm.image3"));
				this.smImages.push(smImageArray);
			}
		}
		callback(null);
	}

	/**
	 * @returns none
	 */
	public progrssChange(event: any): void {
		this.Progress(event);
	}

	/**
	 *
	 * @returns none
	 */
	public ngOnInit(): void {
		super.ngOnInit();
		if (this.modeviewadvice) {
			let componentPostureTab = this.defaultLayouts.components.find(
				(x) => x.component == "app-posture-tab"
			);
			if (componentPostureTab) {
				let safeAreaInsetBottom =
					parseFloat(
						getComputedStyle(
							document.documentElement
						).getPropertyValue("--safe-area-inset-bottom")
					) || 0;
				componentPostureTab.size = [
					690,
					window.innerHeight - 126 - safeAreaInsetBottom,
				];
				console.log("app-posture-tab size", componentPostureTab);
			}
		}
		if (this.modeviewavg) {
			let componentPostureTab = this.defaultLayouts.components.find(
				(x) => x.component == "app-posture-tab"
			);
			if (componentPostureTab) {
				let safeAreaInsetBottom =
					parseFloat(
						getComputedStyle(
							document.documentElement
						).getPropertyValue("--safe-area-inset-bottom")
					) || 0;
				componentPostureTab.size = [
					690,
					window.innerHeight - 126 - safeAreaInsetBottom,
				];
				console.log("app-posture-tab size", componentPostureTab);
			}
		}
		this.aligns = this.defaultLayouts;

		this.draw(this.data);
	}

	/**
	 * @param event
	 * @returns none
	 */
	public draw(event: any) {
		try {
			this.Progress(true);
			this.drawContent(event, (error) => {
				this.Progress(false);
			});
		} catch (error: any) {
			this.errorDialog(error);
		}
	}

	/**
	 * @returns none
	 */
	public isBallistic(): boolean {
		return this.ballistic;
	}

	/**
	 * @returns
	 */
	public Criterion(index: number): boolean {
		let result = false;
		const component = this.aligns.components[index];
		if (component) {
			result = component.criterion;
		}
		return result;
	}

	/**
	 * @returns size
	 */
	public Size(index: number): number[] {
		let result = [100, 100];
		const component = this.aligns.components[index];
		if (component) {
			result = component.size;
		}
		return result;
	}
}
